// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QF1l","index":"styles_index__z74mn"};